import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/Spaces.module.styl'
import bg from '~/assets/img/Menina-e-cachorro.jpg'
import { useLanguage } from '~/hooks'

export default function Spaces() {
  const { t } = useLanguage()
  return (
    <section className={st.core}>
      <Lazyload src={bg} className={st.bg} />
      <h3>
        <span>
          {t('Spaces.title.1')}
          <br />
          {t('Spaces.title.2')}
        </span>
      </h3>
    </section>
  )
}
